export default __webpack_public_path__ + "static/media/fi_archive_approved.a8ba92b6.svg";